import axios from 'axios';
import { graphqlUrl } from './graphqlUrl';

const fields = `id title type revisions {
  revisionId pdfUrl status publishedAt acceptanceRequired requiresReacceptance
}`;

async function request(query, variables, field, pdf) {
  let body = { query, variables };
  if (pdf) {
    body = new FormData();
    body.append('operations', JSON.stringify({ query, variables }));
    body.append('map', JSON.stringify({ '0': ['variables.pdf'] }));
    body.append('0', pdf, pdf.name);
  }
  const response = await axios.post(graphqlUrl, body, {
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  });
  if (response.data.errors && response.data.errors.length) {
    throw new Error(response.data.errors.map(error => error.message).join('\n'));
  }
  const result = response.data.data && response.data.data[field];
  if (result == null) throw new Error('Сервер не подтвердил операцию с документом.');
  return result;
}

// Provisional server contract: docs/documents-api.md.
export default {
  list(page, first) {
    return request(`query($page: Int!, $first: Int!) {
      adminDocuments(page: $page, first: $first) {
        data { id title type }
        paginatorInfo { total }
      }
    }`, { page, first }, 'adminDocuments');
  },
  get(id) {
    return request(`query($id: ID!) { adminDocument(id: $id) { ${fields} } }`,
      { id }, 'adminDocument');
  },
  create(input, pdf) {
    return request(`mutation($input: CreateDocumentInput!, $pdf: Upload!) {
      createDocument(input: $input, pdf: $pdf) { ${fields} }
    }`, { input, pdf: null }, 'createDocument', pdf);
  },
  createRevision(documentId, input, pdf) {
    return request(`mutation($documentId: ID!, $input: DocumentRevisionInput!, $pdf: Upload!) {
      createDocumentRevision(documentId: $documentId, input: $input, pdf: $pdf) { ${fields} }
    }`, { documentId, input, pdf: null }, 'createDocumentRevision', pdf);
  },
  publish(revisionId, input) {
    return request(`mutation($revisionId: ID!, $input: DocumentRevisionInput!) {
      publishDocumentRevision(revisionId: $revisionId, input: $input) { ${fields} }
    }`, { revisionId, input }, 'publishDocumentRevision');
  }
};
